import tw from "src/utils/tw";

interface Props {
  children: React.ReactNode;
  className?: string;
}

export default function ScrollContent(props: Props) {
  return (
    <div
      id="scroll"
      className={tw(
        "md:overflow-auto",
        "h-full",
        "flex-1",
        "sm:h-auto",
        props.className
      )}
    >
      {props.children}
    </div>
  );
}
